import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { expelFromZone, expellMerberZone, seeCommunityMembers } from '../../actions/userActions';
import ZoneMembersView from '../../containers/Zones/ZoneMembers/ZoneMembers';

const ZoneMembers = ({match}) => {
    const {communityMembers} = useSelector(state=>state.userInfo)
    
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(seeCommunityMembers(match.params.zoneId))
    
      return () => {
        
      };
    }, [match.params.zoneId]);
    const report = (id)=>{
      
    }
    const expel = (member)=>{
      console.log();
      dispatch(expellMerberZone(member._id))
    }
    
    
  return <ZoneMembersView members={communityMembers} report={report} expel ={expel}/>
};

export default ZoneMembers;
